<template>
  <div>
    <!-- <v-list
      v-if="props.reports && props.reports.length > 0"
      class="report-list"
    >
      <template v-for="(report, index) in props.reports" :key="report.id">
        <ReportListItem :report="report" />
        <v-divider v-if="index < props.reports.length - 1" />
      </template>
    </v-list> -->
    <ReportCard
      v-for="report in props.reports"
      :key="report.id"
      :report="report"
    />
  </div>
</template>

<script setup>
import ReportCard from "./ReportCard.vue";

// Define props
const props = defineProps({
  reports: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped>
.report-list {
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
</style>
